import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface Props {
  children: ReactNode;
  adminOnly?: boolean;
}

export default function AuthGuard({ children, adminOnly = false }: Props) {
  const { user, profile, profileComplete, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 border-4 border-gray-200 border-t-[#D4A574] rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // ログイン済みだがプロフィール未完了（DBトリガーで行は出来たが Step2 未入力）の場合は
  // 登録フローへ誘導して必須項目を埋めてもらう。/register 側でセッションを検出して Step2 を表示する。
  if (!profileComplete) {
    return <Navigate to="/register" state={{ from: location }} replace />;
  }

  if (adminOnly && !profile?.is_admin) {
    return <Navigate to="/mypage" replace />;
  }

  return <>{children}</>;
}
